import React, {useState} from 'react';
import PropTypes from 'prop-types';
import "./index.css";
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import assets from "../../../../../util/assets";
import util from "../../../../../util/clipstore/user/home";
import {getData, LOGIN} from "../../../../../util/storage";
import {isEmpty} from "../../../../../util/utility";
import pricing from "../../../../../util/clipstore/user/pricing";
import SelectPrice from "../../../../clipstore/user/home/details/pricing";
import WalletBalanceBarComponent from "../../../../Wallet/BalanceBar";
import ProgressiveImage from "react-progressive-image";

const checkIfLoggedIn = (setLoggedIn) => {
    util.checkLoggedIn((isLoggedIn) => {
        setLoggedIn(isLoggedIn)
    })
}

SubscribeToBroadcasterModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    broadcaster: PropTypes.object.isRequired,
    subscribeAmount: PropTypes.number.isRequired,
};

function SubscribeToBroadcasterModal(props) {

    const prices = pricing.set(0, 0, 0, props.subscribeAmount,"subscription")
    const [isLoggedIn, setLoggedIn] = useState(false);
    const anySelection = prices.filter(function (price) {
        return price.isSelected
    });
    checkIfLoggedIn(setLoggedIn)

    return (
        <Modal isOpen={props.isOpen} style={{width: 400}}>
            <ModalHeader className="border-0">

            </ModalHeader>
            <ModalBody className="justify-content-center">
                <div className="broadcaster-profile-container-subscription">
                    <ProgressiveImage
                        delay={1000}
                        src={props.broadcaster.profile_pic}
                        placeholder="placeholder"
                    >
                        {(src, loading) => {
                            return loading ? (
                                    <img alt="broadcaster profile picture"
                                         className="broadcaster-profile-container-subscription-user-section-profile-pic"
                                         src={assets.user_placeholder}/>
                                ) :
                                (
                                    <div className="broadcaster-profile-container-subscription-user-section-profile-pic"
                                         style={{
                                             backgroundImage: "url('" + props.broadcaster.profile_pic + "')"
                                         }}>

                                        <img
                                            src={props.broadcaster.is_verified === 1 ? assets.clipstore.home.broadcaster_verified : assets.clipstore.home.broadcaster_unverified}
                                            alt="verified broadcaster"/>
                                    </div>
                                )

                        }}
                    </ProgressiveImage>

                    <div
                        className="broadcaster-profile-container-subscription-username">{props.broadcaster.username}</div>
                    <div
                        className="broadcaster-profile-container-subscription-description">{props.broadcaster.channel_description}</div>
                    <div className="broadcaster-profile-container-subscription-bullet-container">
                        <div style={{marginBottom:20}}>
                            <img src={assets.broadcaster.profile.tick} alt={"tick"}/>
                            <span className="broadcaster-profile-container-subscription-bullet">Access to broadcaster paid videos</span>
                        </div>
                        <div>
                            <img src={assets.broadcaster.profile.tick} alt={"tick"}/>
                            <span className="broadcaster-profile-container-subscription-bullet">Discount on Exclusive videos</span>
                        </div>
                    </div>

                </div>
                <Row>
                    <Col className="premium-content-modal-column1">
                        {
                            prices.map((price, index) => {
                                if (price.amount !== 0) {
                                    return (
                                        <SelectPrice
                                            key={`select-payment-option-${index}`}
                                            isSelected={price.isSelected}
                                            name={price.name}
                                            label={price.label}
                                            value={price.value}
                                            description={price.description}
                                            amount_formatted={price.amount_formatted}
                                            setPaymentChoice={()=>{

                                            }}
                                        />
                                    )
                                }
                            })
                        }

                        <WalletBalanceBarComponent
                            setWalletBalance={props.setWalletBalance}
                            showMoneyBloxModal={props.showMoneyBloxModal}
                            history={props.history}
                            location={props.location}
                        />
                    </Col>
                </Row>
                <div className="divider-copy"/>
            </ModalBody>
            <ModalFooter className="border-0 justify-content-center">
                <Row className="no-margin">
                    <Col sm="6" className="my-library-title no-padding text-align-left"/>
                    <Col sm="6"
                         className="no-padding display-flex-vertical-center padding-16">
                        <Button color="outline-secondary" onClick={props.toggle} style={{width: 136,marginRight:20}}>
                            CANCEL
                        </Button>

                        <Button color="primary" style={{width: 136}} disabled={anySelection.length === 0 || !isLoggedIn}
                                onClick={() => {
                                    getData(LOGIN).then((data) => {
                                        if (!isEmpty(data)) {
                                            pricing.subscribeToBroadcaster(props, props.broadcaster.id)
                                        }
                                    });
                                }}>
                            {
                                props.purchase_content.isFetching
                                    ?
                                    <img
                                        src={assets.loading_white}
                                        alt={"Loading"}
                                        width={26}
                                        height={26}
                                    />
                                    :
                                    "REQUEST"
                            }

                        </Button>
                    </Col>
                </Row>
            </ModalFooter>
        </Modal>
    );
}

export default SubscribeToBroadcasterModal;